import React from 'react';

import RadioButton, { IRadioButtonProps, RadioButtonOptions } from './RadioButton';

type Props = Omit<IRadioButtonProps, 'options' | 'formLabel'> & {
  formLabel?: string;
  variant?: '1' | '2';
};

const RadioTypePerson: React.FC<Props> = ({
  id,
  formLabel = 'Pessoa',
  labelPlacement,
  formik,
  disabled = false,
  variant = '1',
  ...rest
}) => {
  const options: RadioButtonOptions[] =
    variant === '1'
      ? [
          { value: 'individual', label: 'Física' },
          { value: 'legal', label: 'Jurídica' },
        ]
      : [
          { value: 'legal', label: 'Jurídica' },
          { value: 'individual', label: 'Física' },
        ];

  return (
    <RadioButton
      formLabel={formLabel}
      id={id}
      labelPlacement={labelPlacement}
      options={options}
      formik={formik}
      disabled={disabled}
      variant={variant}
      {...rest}
    />
  );
};

export default RadioTypePerson;
